var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationpoint = function SvgExclamationpoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.001,
    r: 9,
    fill: "#13295B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEF2F6",
    d: "m9.744 4.729-.264 6h-.96l-.264-6zm-.072 8.544H8.328v-1.308h1.344z"
  })));
};
export { SvgExclamationpoint as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSI5IiBjeT0iOS4wMDA5OCIgcj0iOSIgZmlsbD0iIzEzMjk1QiIvPjxwYXRoIGQ9Ik05Ljc0NDEgNC43MjlMOS40ODAxIDEwLjcyOUg4LjUyMDFMOC4yNTYxIDQuNzI5SDkuNzQ0MVpNOS42NzIxIDEzLjI3M0g4LjMyODFWMTEuOTY1SDkuNjcyMVYxMy4yNzNaIiBmaWxsPSIjRUVGMkY2Ii8+PC9zdmc+Cg==";